export const sleep: (time: number) => any = time => {
  return new Promise(resolve => setTimeout(resolve, time))
}
